import { useTranslation } from 'next-i18next'

import { LeagueNames } from '~/Leaderboard/types/leaderboard.types'

import { getLeagueName } from '~/Leaderboard/utils/utils'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import ExpandButton from '~/components/QuestPanel/components/ExpandButton'

export default function LeagueBadgeItem({
  highestLeague,
  leagueName,
  onClick,
}: {
  highestLeague?: number
  leagueName: LeagueNames
  onClick: () => void
}): React.ReactElement {
  const { t } = useTranslation('leaderboard')
  const isLocked = leagueName === LeagueNames.UNRANKED || !highestLeague
  const badgeName = getLeagueName(isLocked ? 1 : highestLeague)

  const onItemClick = (): void => {
    if (!isLocked) onClick()
    else return
  }

  return (
    <button
      className={`${isLocked ? 'opacity-10' : ''} bg-white rounded px-1 py-0.5 cursor-pointer`}
      onClick={onItemClick}
    >
      <div className="h-[65px] w-[49px] md:h-[130px] md:w-[110px] flex flex-col justify-between gap-0.5 py-0.5">
        <div className="h-full flex items-center justify-center">
          <ResponsiveImage
            alt={t(`league.${leagueName}`)}
            className={`${isLocked ? 'brightness-0' : ''} m-auto object-contain`}
            height={100}
            imageClassName="max-h-10 md:max-h-24"
            srcKey={`gamification/badges/league/${badgeName}-badge.svg`}
            width={84}
          />
        </div>
        <ExpandButton disabled={isLocked} />
      </div>
    </button>
  )
}
